import { SEARCH_MATCH_HIGHLIGHT_ATTRIBUTE } from '../documentation-article.const'

import { buildSearchMatchTerms } from './buildSearchMatchTerms'
import { findSearchMatchTextNode } from './findSearchMatchTextNode'

function wrapMatch(match: { node: Text; start: number; length: number }): HTMLElement | null {
  const range = document.createRange()
  range.setStart(match.node, match.start)
  range.setEnd(match.node, match.start + match.length)

  const mark = document.createElement('mark')
  mark.setAttribute(SEARCH_MATCH_HIGHLIGHT_ATTRIBUTE, '')

  try {
    range.surroundContents(mark)
    return mark
  } catch {
    const parent = match.node.parentElement
    if (!parent) {
      return null
    }

    parent.setAttribute(SEARCH_MATCH_HIGHLIGHT_ATTRIBUTE, '')
    return parent
  }
}

export function highlightSearchMatch(root: ParentNode, query: string): HTMLElement | null {
  for (const term of buildSearchMatchTerms(query)) {
    const match = findSearchMatchTextNode(root, term)
    if (match) {
      return wrapMatch(match)
    }
  }

  return null
}
